var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeCaixa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 111,
    viewBox: "0 0 125 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.401 53.578C104.401 54.6821 103.505 55.578 102.401 55.578H88.5833C87.4792 55.578 86.5833 54.6821 86.5833 53.578V27.9478H4V106.385H120.661V27.9478H104.401",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.896 15.9739H11.7658L5.94287 23.9478H118.724L112.896 15.9739Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.974 11.974L104.151 4H20.5158L14.6929 11.974H109.974Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 52.5H102.5V26H88.5V52.5Z",
    fill: "#4A5056"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 106.385H120.661V27.9478H4V106.385ZM122.661 110.385H2C0.895833 110.385 0 109.489 0 108.385V25.9478C0 24.8436 0.895833 23.9478 2 23.9478H122.661C123.771 23.9478 124.661 24.8436 124.661 25.9478V108.385C124.661 109.489 123.771 110.385 122.661 110.385Z",
    fill: "#4A5056"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.667 27.9479C122.047 27.9479 121.443 27.6615 121.047 27.125L104.146 4H20.5158L3.61993 27.125C2.96368 28.0208 1.70847 28.2083 0.823056 27.5625C-0.0675678 26.9115 -0.265486 25.6562 0.390765 24.7656L17.8908 0.817708C18.2658 0.302084 18.8647 0 19.5001 0H105.162C105.802 0 106.401 0.302084 106.776 0.817708L124.276 24.7656C124.932 25.6562 124.735 26.9115 123.844 27.5625C123.49 27.8229 123.073 27.9479 122.667 27.9479Z",
    fill: "#4A5056"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.911 15.9739H10.75C9.65104 15.9739 8.75 15.078 8.75 13.9739C8.75 12.8697 9.65104 11.9739 10.75 11.9739H113.911C115.016 11.9739 115.911 12.8697 115.911 13.9739C115.911 15.078 115.016 15.9739 113.911 15.9739Z",
    fill: "#4A5056"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.401 55.578H88.5835C87.4793 55.578 86.5835 54.6821 86.5835 53.578V25.9478C86.5835 24.8436 87.4793 23.9478 88.5835 23.9478C89.6877 23.9478 90.5835 24.8436 90.5835 25.9478C90.5835 35.957 90.5835 41.5687 90.5835 51.578H100.401V25.9478C100.401 24.8436 101.297 23.9478 102.401 23.9478C103.505 23.9478 104.401 24.8436 104.401 25.9478V53.578C104.401 54.6821 103.505 55.578 102.401 55.578Z",
    fill: "#4A5056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCaixa);
export default __webpack_public_path__ + "static/media/icone-caixa.e27968fc169af05eab9024cddf9802bc.svg";
export { ForwardRef as ReactComponent };